// extracted by mini-css-extract-plugin
export default {"new_testimonial_card":"NewTestimonial_new_testimonial_card__SFW5V","testimonial_user":"NewTestimonial_testimonial_user__RS90t"};